module.exports = __webpack_public_path__ + "static/20-slideshow-b8bb63fc0af6c5c74c30f6cfb8b34fb2.jpg";